import React, { memo, useEffect, useState } from 'react';
import { Clock } from '../assets';
import { calculationTimeDelay } from '../../helpers/delayCalculator';
import { useTranslation } from 'react-i18next';
var TimeDelayIndicator = function (_a) {
    var preTime = _a.preTime, postTime = _a.postTime;
    var _b = useState(''), color = _b[0], setColor = _b[1];
    var _c = useState(''), timeDelay = _c[0], setTimeDelay = _c[1];
    var t = useTranslation().t;
    useEffect(function () {
        var duration = calculationTimeDelay(preTime, postTime);
        if (duration.timeDelaySecond < 60) {
            setColor('#1DAB8B');
        }
        else if (duration.timeDelaySecond < 1800) {
            setColor('#F1C21B');
        }
        else {
            setColor('#FF2340');
        }
        setTimeDelay(duration.timeDelay);
    }, [preTime, postTime]);
    return React.createElement(React.Fragment, null, timeDelay.trim() !== '' &&
        React.createElement("span", { className: 'timeSvg', title: t("TS_core:DelayWithColon") + timeDelay.trim(), style: {} },
            React.createElement(Clock, { fillColor: color })));
};
export default memo(TimeDelayIndicator);
